import React from 'react';
import { StartBotPromoterPanel } from '../../common/StartBotPromoterPanel/StartBotPromoterPanel';

export const CustomerChatPanel = () => {
  return <StartBotPromoterPanel kind="customer_chat" />;
};
